<template>
  <div class="alert-create-modal-wrapper">
    <a-modal
      id="alert-create-modal"
      v-model="visible"
      :title="null"
      :footer="null"
      :closable="false"
      :mask-closable="false"
      centered
    >
      <div class="content-wrapper">
        <img :src="imgLogo" alt="logo" />
        <div class="detail">
          <strong>{{ title }}</strong>
          <span>{{ desc }}</span>
        </div>
        <div class="action-wrapper">
          <div v-if="success && type == 'digital'" class="action-success">
            <a-button class="topup-btn" @click="goto('myCard')">
              {{ lbl.value_design.create_card.modal_alert.my_card_btn }}
            </a-button>
            <a class="go-home" @click="goto('home')">
              {{ lbl.value_design.create_card.modal_alert.back_home_btn }}
            </a>
          </div>
          <div v-if="success && type == 'physical'" class="action-success">
            <a-button class="topup-btn" @click="goto('home')">
              {{ lbl.value_design.create_card.modal_alert.back_home_btn }}
            </a-button>
          </div>
          <div v-if="!success" class="action-fail">
            <a-button class="back-btn" @click="goto('home')">
              {{ lbl.value_design.create_card.modal_alert.back_btn }}
            </a-button>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import Account from '@/helper/AccountHelper.js'
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'

export default {
  name: 'AlertCreateModal',
  mixins: [CommonMixin, ResponsiveMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
    },
    success: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Title',
    },
    desc: {
      type: String,
      default: 'Description',
    },
  },
  data() {
    return {
      visible: false,
      imgLogo: null,
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.visible = val
      },
    },
    success: {
      immediate: true,
      handler(val) {
        if (val) {
          this.imgLogo = require('@/assets/images/valueDesign/card_success.svg')
        } else {
          this.imgLogo = require('@/assets/images/valueDesign/card_fail.svg')
        }
      },
    },
  },
  methods: {
    showModal() {
      this.visible = true
    },
    goto(name) {
      Account.bzbsAnalyticTracking(
        `add_card_page`,
        `value_design`,
        `click_go_to_${name}`,
        'on click',
      )
      this.$router.push({ name: name })
    },
  },
}
</script>
<style lang="scss" scoped>
#alert-create-modal {
  .content-wrapper {
    text-align: center;
    img {
      width: 120px;
      height: 120px;
      margin-bottom: 8px;
    }
    .detail {
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin-bottom: 16px;

      strong {
        font-size: 16px;
        color: #424242;
      }
      span {
        color: #757575;
      }
    }
    .action-wrapper {
      .action-success {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .topup-btn {
          display: flex;
          text-align: center;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 40px;
          padding: 16px 24px;
          border-radius: 100px;
          border-color: #f9a601;
          background: #f9a601;
          color: #ffffff;
          font-weight: 500;
        }
        .go-home {
          color: #f9a601;
          font-weight: 500;
          text-align: center;
        }
      }
      .action-fail {
        .back-btn {
          display: flex;
          text-align: center;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 40px;
          padding: 16px 24px;
          border-radius: 100px;
          border-color: #c9c9c9;
          background: #ffffff;
          color: #4a4a4a;
        }
      }
    }
  }
}
</style>
<style>
.ant-modal-body {
  padding: 24px 16px !important;
}
</style>
